import TablePagination, { LabelDisplayedRowsArgs } from '@mui/material/TablePagination';
import {
  useGridApiContext,
  useGridSelector,
  gridPaginationModelSelector,
  gridPaginationRowCountSelector,
} from '@mui/x-data-grid-pro';
import { useTranslation } from 'react-i18next';
import SpinnerImage from 'assets/images/spinner.svg';
import Container from '@mui/material/Container';
import { toLocaleBrowserSettings } from 'src/i18n/numberLocale';
import { pxToRem } from 'src/common/utils/fonts';

const DisplayedRowsLabel = ({ from, to, count }: LabelDisplayedRowsArgs) => {
  const formatedFrom = toLocaleBrowserSettings(from);
  const formatedTo = toLocaleBrowserSettings(to);
  if (count === -1) {
    return (
      <Container
        sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
        component="span"
      >
        {`${formatedFrom}–${formatedTo} of `}
        <Container
          disableGutters
          component="span"
          sx={{
            display: 'flex',
            width: pxToRem(16),
            m: 0,
            ml: 4,
            animation: 'spin 2s linear infinite',
            '@keyframes spin': {
              '0%': {
                transform: 'rotate(0deg)',
              },
              '100%': {
                transform: 'rotate(360deg)',
              },
            },
          }}
        >
          <SpinnerImage />
        </Container>
      </Container>
    );
  }

  return `${formatedFrom}–${formatedTo} of ${toLocaleBrowserSettings(count)}`;
};

export const Pagination = () => {
  const { t } = useTranslation();
  const apiRef = useGridApiContext();
  const pageCount = useGridSelector(apiRef, gridPaginationRowCountSelector);
  const paginationModel = useGridSelector(apiRef, gridPaginationModelSelector);

  return (
    <TablePagination
      data-testid="pagination"
      component="div"
      color="primary"
      showLastButton={false}
      count={pageCount}
      page={paginationModel.page}
      rowsPerPageOptions={[25, 50, 100]}
      onPageChange={(_event, newPage) => {
        apiRef.current.setPage(newPage);
        apiRef.current.setExpandedDetailPanels(new Set());
      }}
      rowsPerPage={paginationModel.pageSize}
      onRowsPerPageChange={(event) => {
        apiRef.current.setPageSize(Number.parseInt(event.target.value));
      }}
      labelRowsPerPage={t('common.rowsPerPage')}
      labelDisplayedRows={DisplayedRowsLabel}
    />
  );
};
